export const workplanWarningStyles = (theme) => {
    return {
        accordion: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        },
        accordionDetails: {
            flexDirection: 'column',
            padding: 0,
        },
        accordionTitle: {
            fontSize: 18,
            fontWeight: 700,
        },
        employeeName: {
            fontWeight: 700,
            fontSize: 14,
        },
        employeeBox: {
            marginBottom: 5,
            cursor: 'pointer',
        },
        listItem: {
            display: 'flex',
        },
        sideBar: {
            width: 500
        },
        subCategoryPaper: {
            padding: '0 16px',
        },
        subCategoryTitle: {
            fontWeight: 700,
            fontSize: 16,
        },
        tabIcon: {
            color: '#0A54A2'
        },
        tabLabel: {
            fontWeight: 700,
            fontSize: 14,
        },
        userPaper: {
            padding: 5,
        },
        warningBadge: {
            backgroundColor: '#DE1010',
            color: '#FFF'
        },
        warningIcon: {
            color: '#BEBEBE'
        },
        warningIconButton: {
            width: '45px',
            height: '45px',
            '&:focus': {
                outline: 'none'
            }
        },
        warningMessage: {
            fontSize: 14,
            whiteSpace: 'pre-line',
        },
        loadingContainer: {
            display: 'flex',
            alignItems: 'center',
            marginTop: '10px',
            marginLeft: '8px',
        },
    }
}